import { isNil } from 'lodash';


export function stringEmpty(str: string | undefined | null): str is ('' | null | undefined) {
  return isNil(str) || typeof str !== 'string' || str.length === 0;
}
